import { render, staticRenderFns } from "./SpuOnSale.vue?vue&type=template&id=76d13e51&scoped=true"
import script from "./SpuOnSale.vue?vue&type=script&lang=js"
export * from "./SpuOnSale.vue?vue&type=script&lang=js"
import style0 from "./SpuOnSale.vue?vue&type=style&index=0&id=76d13e51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d13e51",
  null
  
)

export default component.exports